import fetch from 'services/request';
import { ILoginRequest } from '../interfaces/api';

// const baseURL = 'api/v1/:merchant_code/demoData';

export const getDemoData = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ data: { data: [] } });
    }, 1000);
  });
  // return fetch({
  //   method: 'get',
  //   url: `${baseURL}/getDemoData`,
  //   params: params as any
  // });
};

const login = (data: ILoginRequest) => {
  return fetch({
    method: 'post',
    url: '/api/v1/auth/login',
    body: data,
  });
};

const authApis = {
  getDemoData,
  login,
};

export default authApis;
